import classNames from 'classnames';
import React, { ComponentProps, FC, ReactNode } from 'react';

import { PdpCarDetail } from '../PdpCarDetail/PdpCarDetail';
import styles from './PdpDetailsBlock.module.scss';

interface PdpCarDetailProps {
  header?: ReactNode;
  items: Prettify<ComponentProps<typeof PdpCarDetail> & { key: string }>[];
  footer?: ReactNode;
  isVertical?: boolean;
  className?: string;
}

export const PdpDetailsBlock: FC<PdpCarDetailProps> = ({ header, footer, items, isVertical, className }) => {
  if (!items.length) return null;
  return (
    <section className={className}>
      {!!header && <h4 className={styles.header}>{header}</h4>}
      <dl className={classNames(styles.list, { [styles.vertical]: isVertical })}>
        {items.map((item) => (
          <PdpCarDetail title={item.title} value={item.value} Icon={item.Icon} key={item.key} />
        ))}
      </dl>
      {footer && <div className={styles.footer}>{footer}</div>}
    </section>
  );
};
